export const MISSING_RECIPIENT_NOTE =
  "Missing a recipient you're looking for? Please complete your page creation and email partners@oath.vote. Additional recipients can be added later.";
